import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function cardmsgB({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div
            className={`${css.cardmsgB} cardmsgB2 GtmModuleData-section`}
            data-section-id={css.cardmsgB}
            data-section-title={t('battery_technology_synopsis2')}
        >
            <div className="card-title">{t('battery_technology_synopsis2')} </div>
            <div className="card-desc">{t('battery_technology_desc2')}</div>
            <div className="card-img">
                <EFPic name={[`10Bms.webp`, `10Bms.png`]} className="fullImgs" alt={t('battery_technology_synopsis2')} />
            </div>
        </div>
    );
}
